import { useCognitoMutation } from '~/client/features/SocialAuth/hooks/useCognitoAuthenticate/CognitoMutation.generated';
import filterAuthResponse from '../helpers/utils';

const useHandleCognitoAuthenticate = () => {
  const [completeCognitoRegistration, { loading }] = useCognitoMutation();
  const handleCognitoAuthenticate = async (
    variables: AuthVariables,
    accessToken: string,
  ) => {
    const response = await completeCognitoRegistration({
      variables: {
        ...variables,
        accessToken,
      },
    });
    return filterAuthResponse(
      response?.data?.userManagementCognitoAuthenticate,
    );
  };
  return {
    handleCognitoAuthenticate,
    loading,
  };
};

export default useHandleCognitoAuthenticate;
